import { Text } from '@rsos/base-components';
import { DebugPanel } from '@rsos/debug-panel';
import V2FlagOverrides from './V2FlagOverrides';

const FlagDebugPanel = ({ onClose }: { onClose?: () => void }) => (
  <DebugPanel title="Feature Flag Override" onClose={onClose}>
    <Text color="secondaryText" size="small">
      These overrides are stored locally in your browser and persist until
      cleared. Not all flags will take effect if changed after the page loads.
    </Text>
    <V2FlagOverrides />
  </DebugPanel>
);

export default FlagDebugPanel;
